<template>
  <div class="big-container mx-auto pl-2 mb-8">
    <h3 class="mb-3">
      <span class="text-2xl font-bold">{{ title }}</span>
      <span v-if="subtitle" class="font-funny text-4xl ml-3">{{ subtitle }}</span>
    </h3>
    <scrollable-product-list
      :products="list"
      list-name="Cross Selling"
    />
  </div>
</template>

<script>
import ScrollableProductList from './ScrollableProductList'
export default {
  components: {
    ScrollableProductList
  },
  props: {
    list: {
      required: true,
      type: Array
    },
    title: {
      required: true,
      type: String
    },
    subtitle: {
      required: false,
      type: String,
      default: null
    }
  }
}
</script>
